import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import AddRefuseReason from "../Registration/RefuseReason/addRefuseReason";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import "./prelude.css";
import BottomBar from "../../Components/bottomBar/bottomBar";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";
import Api from "../../services/api";
import { Redirect } from "react-router-dom";
import AlterReason from "../Registration/RefuseReason/altRefuseReason";
import DelReason from "../Registration/RefuseReason/delRefuseReason";
import { handleColor } from "../../services/Functions";
import ReportReasonsRefuse from "../Reports/reportReasonsRefuse";
import { DrawerMenu } from "../../Components/DrawerMenu/DrawerMenu";

class Sidebar extends React.Component {
  state = { data: [], render: false, redirect: false, click: false };

  async componentDidMount() {
    let array = [];
    await Api.get("/refuse-reasons")
      .then((response) => {
        response.data.forEach((element) => {
          array.push({
            Código: element.code,
            Motivos: element.description,
          });
        });
        if (array.length > 0) this.setState({ data: array, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
    var viewport = document.querySelector("meta[name=viewport]");
    viewport.setAttribute(
      "content",
      viewport.content + ", height=" + window.innerHeight
    );
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { redirect } = this.state;
    const items = [
      { id: "lg1", label: "Motivos de Refugos", eventKey: "list" },
      { id: "lg2", label: "Adicionar Motivo", eventKey: "add" },
      { id: "lg3", label: "Alterar Motivo", eventKey: "alt" },
      { id: "lg4", label: "Deletar Motivo", eventKey: "del" },
      { id: "lg5", label: "Paradas", eventKey: "stop" },
    ];

    if (redirect) return <Redirect to="/motivos"></Redirect>;

    return (
      <Tab.Container activeKey={this.props.activeTab}>
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1">
            <div
              className={this.props.isMobile ? "sidebar2-mobile" : "sidebar2"}
            >
              <Col className="sidebarColumn" mountOnEnter unmountOnExit>
                <ListGroup>
                  {items.map((item) =>
                    this.props.isMobile ? (
                      <Col key={item.id} xs={12}>
                        <ListGroup.Item
                          id={item.id}
                          onClick={() => {
                            this.props.setActiveTab(item.eventKey);
                            if (item.eventKey === "stop") {
                              this.setState({ redirect: true });
                            }
                            this.props.handleClose()
                          }}
                          className="listGroup"
                          eventKey={item.eventKey}
                        >
                          {item.label}
                        </ListGroup.Item>
                      </Col>
                    ) : (
                      <ListGroup.Item
                        key={item.id}
                        id={item.id}
                        onClick={() => {
                          this.props.setActiveTab(item.eventKey);
                          if (item.eventKey === "stop") {
                            this.setState({ redirect: true });
                          }
                        }}
                        className="listGroup d-none d-md-block"
                        eventKey={item.eventKey}
                      >
                        {item.label}
                      </ListGroup.Item>
                    )
                  )}
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col3"
              style={{
                top: "5%",
                marginLeft: "1.5%",
                width: "100%",
               
              }}
            >
              {!this.props.isMobile && (
                <Tab.Content>
                  <Tab.Pane eventKey="list">
                    <ReportReasonsRefuse />
                  </Tab.Pane>
                  <Tab.Pane
                    className="col5"
                    mountOnEnter
                    unmountOnExit
                    eventKey="add"
                  >
                    {this.handleClick ? <AddRefuseReason /> : null}
                  </Tab.Pane>
                  <Tab.Pane
                    className="col5"
                    mountOnEnter
                    unmountOnExit
                    eventKey="alt"
                  >
                    {this.handleClick ? <AlterReason /> : null}
                  </Tab.Pane>
                  <Tab.Pane
                    className="col5"
                    mountOnEnter
                    unmountOnExit
                    eventKey="del"
                  >
                    {this.handleClick ? <DelReason /> : null}
                  </Tab.Pane>
                </Tab.Content>
              )}
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

function prelude_refugo() {
  const [activeTab, setActiveTab] = React.useState("list");

  return (
    <>
      <div>
        <Top_bar title="Cadastro de Refugos" />{" "}
      </div>
      <div className="prelude_container">
        <DrawerMenu>
          <Sidebar
            isMobile
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></Sidebar>
        </DrawerMenu>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}></Sidebar>
      </div>
      <footer>
        <BottomBar></BottomBar>
      </footer>
    </>
  );
}

export default prelude_refugo;
